import Icon from '../components/Icon.vue'

Icon.register({
  'glass-cheers': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M639.4 433.6C631 413.2 607.6 403.5 587.2 412L565.1 421.2 526.4 319.3C574.3 284.3 591.2 219 560.9 166.5L474.3 16C466.3 2.1 449.2-3.7 434.3 2.4L320 49.8 205.7 2.4C190.8-3.8 173.7 2.1 165.7 16L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1 52.8 411.9C32.4 403.4 9.1 413.1 0.6 433.5-1.1 437.6 0.8 442.3 4.9 444L167.2 511.4C171.3 513.1 175.9 511.2 177.6 507.1 186 486.7 176.4 463.3 156 454.8L133.9 445.6 173.3 342C177.7 342.5 182.1 343.3 186.4 343.3 238.1 343.3 285.8 310.2 299.8 258L320 182.6 340.2 258C354.2 310.2 401.9 343.3 453.6 343.3 457.9 343.3 462.3 342.5 466.7 342L506 445.6 483.9 454.8C463.5 463.3 453.8 486.7 462.3 507.1 464 511.2 468.7 513.1 472.7 511.4L635.1 444C639.1 442.3 641.1 437.7 639.4 433.6zM275.9 162.1L163.8 115.6 200.3 52.2 294.8 91.4 275.9 162.1zM364.1 162.1L345.2 91.4 439.7 52.2 476.2 115.6 364.1 162.1z'
      }
    ]
  }
})
